export default "__VITE_ASSET__DqA7PWHj__"